var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty"},[_c('img',{staticClass:"empty-image",attrs:{"src":require("../../../assets/image/jiaxing/empty.png"),"alt":""}}),_c('div',{staticClass:"empty-text"},[_vm._v("暂无培训码信息")])])
}]

export { render, staticRenderFns }